"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNotification = void 0;
const react_1 = __importDefault(require("react"));
const controls_1 = require("../../controls");
const Icon_1 = require("../../Icon");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
function NotificationActions({ items = [] }) {
    const actionItems = items.filter(({ hidden }) => !hidden);
    if (!actionItems.length) {
        return null;
    }
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m }, actionItems.map(({ text, testId, icon, handler }, idx) => (react_1.default.createElement(controls_1.LinkButton, { key: `${testId || ''}${text}${idx}`, compact: true, onClick: handler, iconBefore: icon, "data-selector-id": testId }, text)))));
}
function createNotification(config) {
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m },
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s },
            !!config.icon && react_1.default.createElement(Icon_1.Icon, { src: config.icon }),
            typeof config.content === 'string' ? (react_1.default.createElement(Text_1.Text, null, config.content)) : (config.content)),
        react_1.default.createElement(NotificationActions, { items: config.actions })));
}
exports.createNotification = createNotification;
//# sourceMappingURL=createNotification.js.map